'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class reportWpDeliverableModel extends ngDepModel
{
	a4_1_work_activities_deliv_type_other = false;
	a4_1_work_activities_deliv_type_other_value = '';
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
		this.a4_1_work_activities_deliv_type_other = (this.a4_1_work_activities_deliv_type_other > 0 || true === this.a4_1_work_activities_deliv_type_other);
		this.deliverable_title = (this.a4_1_work_activities_deliv_no ? this.a4_1_work_activities_deliv_no + ' ' : '')
			+ (this.a4_1_work_activities_deliv_name || '');
	}
	
	getValue(name){
		switch(name){
			case 'status':
				return this.getClassifValue(name, 'report_deliverable_status');
			case 'a4_1_work_activities_deliv_level':
				return this.getDisplayValue(name);
			case 'proposed_due_date':
			case 'new_due_date':
			case 'due_date_date':
			case 'delivery_date':
			case 'approval_date':
			case 'a4_1_work_activities_deliv_due_date':
				if(this[name] == 0){
					return '';
				}
//				return this.s('$filter')('u2date')(this[name], 'dd/MM/y');
				return this.s('$filter')('u2date')(this[name]);
			case 'a4_1_work_activities_deliv_type':
				if(this.a4_1_work_activities_deliv_type_other){
					return this.a4_1_work_activities_deliv_type_other_value;
				}
				return this.getClassifValue('a4_1_work_activities_deliv_type_id', 'deliverablestype');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
